// project import
import other from "./other";
import main from "./main";

const menuItems = {
  items: [main, other],
};

export default menuItems;
